import React from 'react';
import { Grid } from "@material-ui/core";
import { H1, Regular } from '@worthy-npm/clarity';

import { isMobile, isTablet } from '../filters/filter_constants_and_helpers.jsx.erb';

class RecentDealsHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Grid
                container
                style={{
                    marginTop: `${isMobile() && !isTablet() ? '10px' : '70px'}`,
                    marginBottom: `${isMobile() && !isTablet() ? '24px' : '85px'}`
                }}
            >
                <Grid item sm={12} xs={12} md={12} lg={12} style={{ textAlign: 'center', textTransform: 'none' }}>
                    <H1 text="Recent Auctions"
                        overrideCSS={{
                            font: `700 ${isMobile() ? '36px' : '48px'} Playfair Display`,
                            marginBottom: '12px'
                        }}
                    />
                    <Regular text= "Explore your jewelry's potential value below."
                             overrideCSS={{ font: '300 18px Roboto'}}/>
                </Grid>
            </Grid>
        )
    }
}
export default RecentDealsHeader;
